module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("Nome:")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nome),
      expression: "nome"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "text",
      "name": "nome"
    },
    domProps: {
      "value": (_vm.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nome = $event.target.value
      }
    }
  }), _c('input-errors', {
    attrs: {
      "name": "nome"
    }
  })], 1), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("Cor:")]), _c('color-palette', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "cor"
    },
    on: {
      "input": _vm.onCorChange
    },
    model: {
      value: (_vm.cor),
      callback: function($$v) {
        _vm.cor = $$v
      },
      expression: "cor"
    }
  }), _c('input-errors', {
    attrs: {
      "name": "cor"
    }
  })], 1), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("Arquivo shape:")]), _c('shape-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "shapeInput",
    attrs: {
      "name": "shape",
      "max-file-size": 10
    },
    on: {
      "input": _vm.onShapeChange
    },
    model: {
      value: (_vm.geoJsonShape),
      callback: function($$v) {
        _vm.geoJsonShape = $$v
      },
      expression: "geoJsonShape"
    }
  }), _c('input-errors', {
    attrs: {
      "name": "shape"
    }
  })], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 mt-2"
  }, [_c('button', {
    staticClass: "btn btn-outline-secondary btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.cancelar()
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-close"
  }), _vm._v(" Cancelar")]), _c('button', {
    staticClass: "btn btn-primary btn-sm float-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.adicionarCamadaShape()
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-check"
  }), _vm._v(" Adicionar")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c3c103c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/adicaoCamadas/AdicaoCamadaShape.vue
// module id = 484
// module chunks = 1